// Unified Desktop + Mobile menu opener (with mobile submenu preselect)
(function () {
  // --- Desktop (mega menu) targets ---
  const desktop = {
    details: document.getElementById('Details-HeaderMenu-3'),            // <details> for "Dine udfordringer?"
    summary: document.getElementById('HeaderMenu-dine-udfordringer'),     // <summary>
    content: document.getElementById('MegaMenu-Content-3')                // panel to focus
  };

  // --- Mobile (drawer) targets ---
  const mobile = {
    drawerDetails: document.getElementById('Details-menu-drawer-container'),               // drawer <details>
    hamburger: document.querySelector('header-drawer summary.header__icon--menu'),         // hamburger <summary>
    drawerPanel: document.getElementById('menu-drawer'),                                   // drawer panel to focus
    // "Dine udfordringer?" submenu inside the drawer:
    submenuDetails: document.getElementById('Details-menu-drawer-menu-item-3'),
    submenuPanel: document.getElementById('link-dine-udfordringer')
  };

  // --- Shared hooks ---
  const header = document.getElementById('shopify-section-sections--26365291364697__header');
  const btn = document.querySelector('.hero__buttons a[href="#open"]'); // your hero trigger
  if (!btn || !header) return;

  // Mobile breakpoint: header-drawer is hidden ≥ 990px
  const mql = window.matchMedia('(max-width: 989px)');

  // ---- helpers ----
  const hasEl = (el) => !!el;
  const isOpen = (el) => hasEl(el) && (el.hasAttribute('open') || el.open === true);
  const setOpen = (el) => hasEl(el) && el.setAttribute('open', '');
  const setClosed = (el) => hasEl(el) && el.removeAttribute('open');

  const syncDesktopAria = () => {
    if (!desktop.summary) return;
    desktop.summary.setAttribute('aria-expanded', isOpen(desktop.details) ? 'true' : 'false');
  };

  const syncHeaderClass = () => {
    // Only affect class on mobile; always clear on desktop
    if (!mql.matches) { header.classList.remove('menu-open'); return; }
    if (isOpen(mobile.drawerDetails)) header.classList.add('menu-open');
    else header.classList.remove('menu-open');
  };

  // ---- desktop actions ----
  const openDesktop = () => {
    if (!desktop.details || !desktop.summary) return;
    if (!isOpen(desktop.details)) {
      setOpen(desktop.details);
      syncDesktopAria();
    }
    desktop.content?.focus?.({ preventScroll: true });
  };

  const closeDesktop = () => {
    if (!desktop.details || !desktop.summary) return;
    if (isOpen(desktop.details)) {
      setClosed(desktop.details);
      syncDesktopAria();
      desktop.summary.focus?.({ preventScroll: true });
    }
  };

  // ---- mobile actions ----
  const openMobile = async ({ preselectSubmenu = false } = {}) => {
    if (!mobile.drawerDetails) return;

    // Prefer clicking the hamburger to keep theme JS/animations in sync
    if (!isOpen(mobile.drawerDetails)) {
      mobile.hamburger ? mobile.hamburger.click() : setOpen(mobile.drawerDetails);
    }

    // Let the drawer apply classes/height for one frame
    await new Promise(requestAnimationFrame);

    if (preselectSubmenu && mobile.submenuDetails) {
      if (!isOpen(mobile.submenuDetails)) {
        const subSummary = mobile.submenuDetails.querySelector('summary');
        subSummary ? subSummary.click() : setOpen(mobile.submenuDetails);
      }
      mobile.submenuPanel?.focus?.({ preventScroll: true });
    } else {
      mobile.drawerPanel?.focus?.({ preventScroll: true });
    }

    syncHeaderClass();
  };

  const closeMobile = () => {
    if (!mobile.drawerDetails) return;
    if (isOpen(mobile.drawerDetails)) {
      // Try clicking again to close so theme JS runs
      if (mobile.hamburger) mobile.hamburger.click();
      else setClosed(mobile.drawerDetails);
    }
    syncHeaderClass();
  };

  // ---- main trigger (hero btn) ----
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    if (mql.matches) {
      // MOBILE: open drawer and preselect "Dine udfordringer?"
      openMobile({ preselectSubmenu: true });
    } else {
      // DESKTOP: open the mega menu for "Dine udfordringer?"
      openDesktop();
    }
  });

  // ---- keep in sync with user actions / other scripts ----
  desktop.details?.addEventListener('toggle', () => {
    syncDesktopAria();
  });

  mobile.drawerDetails?.addEventListener('toggle', () => {
    syncHeaderClass();
  });

  // ---- close on Escape ----
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (mql.matches && isOpen(mobile.drawerDetails)) closeMobile();
    if (!mql.matches && isOpen(desktop.details)) closeDesktop();
  });

  // ---- close on outside click ----
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (mql.matches) {
      const outside = mobile.drawerDetails && !mobile.drawerDetails.contains(t) && t !== btn;
      if (outside && isOpen(mobile.drawerDetails)) closeMobile();
    } else {
      const outside = desktop.details && !desktop.details.contains(t) && t !== btn;
      if (outside && isOpen(desktop.details)) closeDesktop();
    }
  });

  // ---- respond to viewport changes (e.g., rotate device) ----
  mql.addEventListener?.('change', () => {
    // Clear header class when leaving mobile to avoid sticky state
    if (!mql.matches) header.classList.remove('menu-open');
  });

  // ---- initial sync ----
  syncDesktopAria();
  syncHeaderClass();
})();
